module.exports = __webpack_public_path__ + "static/media/logo-horizontal-white.04155b05.svg";